import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const Exam = () => import("@/views/exam/index.vue");
const Login = () => import("@/views/login/index.vue");
const Dashboard = () => import("@/views/dashboard/index.vue");
const ExamNotice = () => import("@/views/exam-notice/index.vue");
const ExamSignUp = () => import("@/views/exam-sign-up/index.vue");
const ExamPrint = () => import("@/views/exam-print/index.vue");
const ExamRegister = () => import("@/views/exam-Register/index.vue");
const ExamAuditStatus = () => import("@/views/exam-audit-status/index.vue");
const ExamPay = () => import("@/views/exam-pay/index.vue");
const ExamExamList = () => import("@/views/exam-examlist/index.vue");

export const constantRoutes = [
  {
    path: "/404",
    component: (resolve) => require(["@/views/error/404"], resolve),
    hidden: true,
  },
  {
    path: "/401",
    component: (resolve) => require(["@/views/error/401"], resolve),
    hidden: true,
  },
  {
    path: "/",
    name: "Home",
    meta: { title: "首页", icon: "" },
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/details",
    name: "details",
    meta: { title: "详情", keepAlive: true, icon: "" },
    component: () => import("@/views/details/index.vue"),
  },
  {
    path: "/details/list",
    name: "details-list",
    meta: { title: "公告列表", keepAlive: true, icon: "" },
    component: () => import("@/views/details/list.vue"),
  },
  {
    path: "/exam",
    name: "exam",
    meta: { title: "考试列表", keepAlive: true, icon: "" },
    component: Exam,
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "登录", keepAlive: true, icon: "" },
    component: Login,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { title: "首页", keepAlive: true, icon: "" },
    component: Dashboard,
    children: [
      {
        path: "/exam-examlist",
        name: "exam-examlist",
        // hidden：报名列表页作为登录后默认展示页，不显示在侧边栏菜单
        meta: { title: "报名列表", keepAlive: true, icon: "", hidden: true },
        component: ExamExamList,
      },
      {
        path: "/exam-notice",
        name: "exam-notice",
        meta: { title: "报名须知", keepAlive: true, icon: "" },
        component: ExamNotice,
      },
      {
        path: "/exam-sign-up",
        name: "exam-sign-up",
        meta: { title: "考生报名", keepAlive: true, icon: "" },
        component: ExamSignUp,
      },
      {
        path: "/exam-audit-status",
        name: "exam-audit-status",
        meta: { title: "报名审核", keepAlive: true, icon: "" },
        component: ExamAuditStatus,
      },
      {
        path: "/exam-pay",
        name: "exam-pay",
        meta: { title: "报名缴费", keepAlive: true, icon: "" },
        component: ExamPay,
      },
      {
        path: "/exam-print",
        name: "exam-print",
        meta: { title: "准考证下载", keepAlive: true, icon: "" },
        component: ExamPrint,
      },
      {
        path: "/exam-register",
        name: "exam-register",
        meta: { title: "资格审核登记表", keepAlive: true, icon: "" },
        component: ExamRegister,
      },
    ],
  },
  {
    path: "/wordView",
    name: "wordView",
    meta: { title: "操作手册", keepAlive: true, icon: "" },
    component: () => import("@/views/wordView/index.vue"),
  },
];

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: "history",
  base: process.env.VUE_APP_PUBLIC_PATH || "/",
  routes: constantRoutes,
});
